<template>
    <div v-if="showModal">
        <div class="backdrop" @click="close"></div>
        <div class="card card-outline card-primary card-box mx-auto">

            <div class="card-header">
                <h3
                    v-if="isParseHtml"
                    v-html="question"
                    class="card-title"
                ></h3>
                <h3
                    v-else
                    class="card-title"
                >{{ question }}</h3>

                <div class="card-tools">
                    <button type="button"
                            class="btn btn-tool"
                            @click="close"
                    >
                        <i class="fas fa-times"></i>
                    </button>
                </div>
            </div>

            <div class="modal-card-body">
                <p></p>
            </div>

            <div class="modal-card-actions text-right">

                <template v-if="!isSwapButtons">
                    <button class="btn btn-primary button-blue mr-2"
                            @click.prevent="confirm"
                    >
                        <span>{{ confirmButtonText }}</span>
                        <span
                            v-if="isLoading"
                            class="spinner-border spinner-border-sm ml-2"
                            role="status"
                            aria-hidden="true"
                        ></span>
                    </button>
                    <button class="btn btn-primary button-blue"
                            @click.prevent="close"
                    >
                        <span>{{ closeButtonText }}</span>
                    </button>
                </template>

                <template v-else>
                    <button class="btn btn-danger mr-2"
                            @click.prevent="close"
                    >
                        <span>{{ closeButtonText }}</span>
                    </button>
                    <button class="btn btn-primary button-blue"
                            @click.prevent="confirm"
                    >
                        <span>{{ confirmButtonText }}</span>
                        <span
                            v-if="isLoading"
                            class="spinner-border spinner-border-sm ml-2"
                            role="status"
                            aria-hidden="true"
                        ></span>
                    </button>
                </template>

            </div>

        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                isLoading: false
            };
        },
        props: {
            showModal: Boolean,
            confirmButtonText: String,
            closeButtonText: String,
            question: String,
            isParseHtml: {
                type: Boolean,
                default: false
            },
            isSwapButtons: {
                type: Boolean,
                default: false
            },
        },
        methods: {
            close() {
                this.$emit('update:showModal', false);
            },
            confirm() {
                this.$emit('update:showModal', false);
                this.$emit('confirmApprove');
            }
        }
    }
</script>
